export default __webpack_public_path__ + "static/media/Header-17.45d09e3a.jpg";